









'use strict';

var RequestAnimationFrame={
current:function current(cb){return global.requestAnimationFrame(cb);},
inject:function inject(injected){
RequestAnimationFrame.current=injected;
}};


module.exports=RequestAnimationFrame;


//////////////////
// WEBPACK FOOTER
// ./node_modules/animated/lib/injectable/RequestAnimationFrame.js
// module id = 27
// module chunks = 0